import { LOGOUT_USER, LOGOUT_USER_SUCCESS } from "./actionTypes"

export const logoutUser = ({ history, onSuccess }) => {
  return {
    type: LOGOUT_USER,
    payload: { history, onSuccess },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}
